// Toggle for console-logging every gRPC call. Read per-call by the logging
// interceptor in api/connect-web-setup.ts and set from the in-app Dev Tools
// dialog (dev environment only). Stored in localStorage so it persists across
// reloads while debugging.
const GRPC_LOG_STORAGE_KEY = "sc:devtools:grpc-log";

export const isGrpcLoggingEnabled = (): boolean => {
  try {
    return localStorage.getItem(GRPC_LOG_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

export const setGrpcLogging = (enabled: boolean): void => {
  try {
    if (enabled) {
      localStorage.setItem(GRPC_LOG_STORAGE_KEY, "1");
    } else {
      localStorage.removeItem(GRPC_LOG_STORAGE_KEY);
    }
  } catch {
    // Ignore storage errors (e.g. Safari private mode).
  }
};
